var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.253,
    height: 16.414,
    viewBox: "0 0 14.253 16.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3642",
    "data-name": "\\uADF8\\uB8F9 3642",
    transform: "translate(-175.042 -133.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2878",
    "data-name": "\\uD328\\uC2A4 2878",
    d: "M191.1,149.313H180V138.808l4.417-4.47H191.1Z",
    transform: "translate(-2.51 0)",
    fill: "none",
    stroke: "#002037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_59",
    "data-name": "\\uC120 59",
    x2: 5.822,
    y2: 5.893,
    transform: "translate(182.766 143.445)",
    fill: "none",
    stroke: "#002037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_60",
    "data-name": "\\uC120 60",
    x1: 3.484,
    y2: 3.526,
    transform: "translate(175.749 134.338)",
    fill: "none",
    stroke: "#002037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2879",
    "data-name": "\\uD328\\uC2A4 2879",
    d: "M175.749,143.6V154.8",
    transform: "translate(0 -5.467)",
    fill: "none",
    stroke: "#002037",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/iconDoc.0e536a6698583b09ab270a7237f44fef.svg";
export { ForwardRef as ReactComponent };